import { brandConfig } from '../../config/brands';

/**
 * 現在のブランドに応じた用語辞書を取得
 * brandConfig.labels + serviceName, brandColor, contactUrl を統合
 */
export function getGlossary(): Record<string, string> {
  return {
    ...brandConfig.labels,
    serviceName: brandConfig.serviceName,
    brandColor: brandConfig.colors.primary,
    contactUrl: brandConfig.urls.contact,
  };
}

/**
 * テキスト内の {{key}} プレースホルダーを用語辞書で置換
 */
export function replaceTerms(text: string, glossary?: Record<string, string>): string {
  const dict = glossary ?? getGlossary();
  return text.replace(/\{\{(\w+)\}\}/g, (match, key) => dict[key] ?? match);
}

export { brandConfig } from '../../config/brands';
